/** 스크립트 실행 */
export function pushDataLayer(obj) {
    dataLayer.push(obj);
}

/** event key 값 설정 */
export function setEventNObj(eventName) {
    let eventObj = { 'event': eventName };
    return eventObj;
}

/** crm양식에 맞게 key 변경 */
export function changeObjKey(keyObj, originalData) {
    // keyObj: crm 형식의 key값 object, originalData: 원본 데이터

    // event명 설정
    let eventObj = setEventNObj(keyObj['event']);

    // originalData key값 변경
    const result = Object.assign(eventObj, (_.mapKeys(originalData, function(value, key) {
        return keyObj[key];
    })));

    // crm 요구 형식이 아닌 key 값 제거
    // : originalData에서 keyObj에 없는 key의 경우 undefined로 set된다. 
    if (result.hasOwnProperty('undefined')) {
        delete result.undefined;
    }

    return result;
}